import axios from 'axios'
import store from './vuex/store'
import moment from "moment";

import { getBuilding } from './building/services/buildingSerivce'
import { getLocation } from './platform/location/services/locationService'
import { getServerApi } from './config/deployment'
import { getAnyFirebaseToken, getCurrentFirebaseUser } from './platform/auth/services/authService.js'

let envUri = getServerApi()
let uri = envUri+'/api/listings/maakler'
let userUri = envUri+'/api/user'

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul','Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
const MONTHS_FULL = ['January', 'February', 'March', 'April', 'May', 'June', 'July','August', 'September', 'October', 'November', 'December' ];

// If today, return time, else return day (short)
// if fail return ''
export let formatToDynamicTime=function(isoDateString){
  try{
    var today = moment()
    var dateInQuestion = moment(new Date(isoDateString))

    if( today.diff(dateInQuestion, "days") == 0 ){
      let minutes= dateInQuestion.minutes()
      minutes<10?minutes='0'+ minutes: void 0;
      return dateInQuestion.hours() + ':' + minutes
    
    } else if (today.diff(dateInQuestion, "weeks") == 0){
      return DAYS[dateInQuestion.days()]
    
    }else{
      let day = dateInQuestion.date()
      day<10?day = "0" + day: void 0;
      return day + " " + MONTHS[dateInQuestion.month()]
    }
  }catch(err){
    return ''
  }
}

export let formatTimeToMonDD=function(isoDateString){
  try{
    var md = new Date(isoDateString)
    return MONTHS[md.getMonth()] +' '+ md.getDate()
  }catch(err){
    return ''
  }
}



export let getMonth=function(isoDateString){
  try{
    var md = new Date(isoDateString)
    return MONTHS_FULL[md.getMonth()]
  }catch(err){
    return ''
  }
}


function filterParts(parts, apartNumber){
  let correctParts = []
  for(let part of parts){
    if(part.partNr == apartNumber) correctParts.push(part)
  }
  return correctParts
}

export const pullAvailableLocAndBuildDataToSS =(locationData)=>{
  getLocation(locationData)
    .then(location => {
      sessionStorage.setItem('locationServiceLoc', JSON.stringify(location))
      if(location.ehrBuildCode && location.ehrBuildCode != ''){
        getBuilding(location.ehrBuildCode, location.number)
          .then(building => {
            if(building.parts.length > 1) building.parts = filterParts(building.parts, locationData.address.apartNumber)
            sessionStorage.setItem('buildingServiceData', JSON.stringify(building))
          })
          .catch(err => {
            console.log("pullAvailableLocAndBuildDataToSS > catch | err:", err)
          })
      }
    })
}

export const addListing = (data) => {
  return getUserTokenActual()
    .then(res => {
      return axios.post(uri, data, {
        params: {
          'token': res
        }
      })
    })
    .then(resp => {
      return resp.data
    })
    .catch(err => {
      return false
    })
}

export function onBeforeAddListingSaveAndExit(){
  store.commit("CLEAR_ALL_PROPERTIES")
}


export const uploadImage = (data) => {
  const config = {
    onUploadProgress: progressEvent => console.log('')
  }
  return axios.post(uri + '/1/uploadImage', data, config)
    .then(resp => {
      return resp.data
    })
}

export const uploadProfileImage = (data) => {
  return axios.post(userUri + '/images', data)
    .then(resp => {
      return resp.data
    })
    .catch(err => {
    })
}

export const getUserUid = () => {
  var user = getCurrentFirebaseUser()
  if (user) {
    return user.uid
  } else {
    return false
  }

}

// IMPORTANT check authService.getCurrentUserToken() for a more optimized version
export const getUserToken = () => {
  return getUserTokenActual()
}

function getUserTokenActual(){
  if(getCurrentFirebaseUser()){
    return getCurrentFirebaseUser().getIdToken(/*true*/)
      .then( token => {
        return token
      })
      .catch(err => {
        console.error("getUserTokenActual > err:", err);
        return false
      });
  }else{
    return Promise.reject("current user not found")
  }
  
}


export const getUserPublicByUId = (id) => {
  return getAnyFirebaseToken()
    .then(res => {
      return axios.get(userUri+'/public', {
        params: {
          uid: id,
          token: res
        }
      })
    })
    .then(resp => {
      return resp.data.body
    })
    .catch(err => {
      return {}
    })
}

export const getUserPublicByMaaklerId = (id) => {
  return getUserTokenActual()
    .then(res => {
      return axios.get(userUri+'/public', {
        params: {
          maaklerId: id,
          token: res
        }
      })
    })
    .then(resp => {
      return resp.data.body
    })
    .catch(err => {
      return {}
    })
}

export const deleteImage = (name) => {
  return axios.delete(uri + '/image', {
    params: {
      imageName: name
    }
  })
}

function objectToString(obj)  {
  var seen = [];

  JSON.stringify(obj, function(key, val) {
     if (val != null && typeof val == "object") {
          if (seen.indexOf(val) >= 0) {
              return;
          }
          seen.push(val);
      }
      return val;
  });
}

let dummyBuildingMultiParts =
{
  "status": "SUCCESS",
  "data": {
      "ehrCode": 120280968,
      "ehrId": 3230274,
      "adsOId": "EE00992557",
      "addresses": [
          {
              "street": "Kotzebue tn",
              "number": "27",
              "fullAD": "Harju maakond, Tallinn, Põhja-Tallinna linnaosa, Kotzebue tn 27",
              "formattedAD": "Kotzebue tn 27"
          }
      ],
      "genDet": {
          "ehrUrl": "https://www.ehr.ee/app/link/b/120280968",
          "mainUsageId": 11222,
          "statusTxt": "EHITIS_SEISUND_KASUTUSEL",
          "structureType": "building",
          "buildingType": "threeOrMoreApartmentBuilding",
          "status": "inUse",
          "buildStartDate": "2005-07-11",
          "yearIntoUse": 2006,
          "countyId": 37,
          "municipalityId": 784
      },
      "techDet": {
          "areaUnit": "m2",
          "lengthUnit": "m",
          "volumeUnit": "m3",
          "projAreaToGrnd": 420,
          "nrOfGrndFlrs": 4,
          "height": 18.1,
          "length": 32.1,
          "width": 15.5,
          "clsdNetArea": 1495.9,
          "heatedArea": 1260.6,
          "lvngArea": 619.5,
          "nonLvngArea": 477.8,
          "grossVolume": 6004,
          "elSystem": [
              "grid"
          ],
          "waterSystem": [
              "grid"
          ],
          "sewageSystem": [
              "grid"
          ],
          "heatTypes": [
              "local"
          ],
          "structureMats": [
              "metal",
              "modularRC",
              "monolithicRC"
          ],
          "extRoofStructures": [
              "modularRC"
          ],
          "intRoofStructures": [
              "modularRC"
          ],
          "extWallCovers": [
              "other"
          ],
          "extRoofCovers": [
              "sheetMet"
          ]
      },
      "parts": [
          {
              "ehrPartCode": "120280968-2457234",
              "inAdsPartOid": "ER01444847",
              "partType": "apartment",
              "buildingNr": "27",
              "partNr": "8",
              "entryFloor": 3,
              "totalArea": 75,
              "heatedArea": 70.5,
              "nrOfRooms": 3,
              "waterTypes": [
                  "grid"
              ],
              "balconies": [
                  {
                      "category": "unk",
                      "areaM2": 4.5
                  }
              ],
              "sanOptions": [
                  "bathAndOrShower"
              ]
          },
          {
              "ehrPartCode": "120280968-2457236",
              "inAdsPartOid": "ER01444849",
              "partType": "apartment",
              "buildingNr": "27",
              "partNr": "9",
              "entryFloor": 3,
              "totalArea": 91.8,
              "heatedArea": 84.6,
              "nrOfRooms": 4,
              "nrOfKitchens": 1,
              "waterTypes": [
                  "grid"
              ],
              "balconies": [
                  {
                      "category": "unk",
                      "areaM2": 7.2
                  }
              ],
              "sanOptions": [
                  "bathAndOrShower"
              ]
          },
          {
              "ehrPartCode": "120280968-2457238",
              "inAdsPartOid": "ER01444853",
              "partType": "apartment",
              "buildingNr": "27",
              "partNr": "10",
              "entryFloor": 3,
              "totalArea": 39.1,
              "heatedArea": 39.1,
              "nrOfRooms": 2,
              "nrOfKitchens": 1,
              "waterTypes": [
                  "grid"
              ],
              "sanOptions": [
                  "bathAndOrShower"
              ]
          },
          {
              "ehrPartCode": "120280968-2457240",
              "inAdsPartOid": "ER01444856",
              "partType": "apartment",
              "buildingNr": "27",
              "partNr": "11",
              "entryFloor": 3,
              "totalArea": 58.9,
              "heatedArea": 58.9,
              "nrOfRooms": 3,
              "waterTypes": [
                  "grid"
              ],
              "sanOptions": [
                  "bathAndOrShower"
              ]
          },
          {
              "ehrPartCode": "120280968-2457242",
              "inAdsPartOid": "ER01444859",
              "partType": "apartment",
              "buildingNr": "27",
              "partNr": "12",
              "entryFloor": 3,
              "totalArea": 59.1,
              "heatedArea": 59.1,
              "nrOfRooms": 3,
              "nrOfKitchens": 1,
              "waterTypes": [
                  "grid"
              ],
              "sanOptions": [
                  "bathAndOrShower"
              ]
          },
          {
              "ehrPartCode": "120280968-2457244",
              "inAdsPartOid": "ER01444862",
              "partType": "apartment",
              "buildingNr": "27",
              "partNr": "13",
              "entryFloor": 4,
              "totalArea": 29.8,
              "heatedArea": 29.8,
              "nrOfRooms": 1,
              "nrOfKitchens": 1,
              "waterTypes": [
                  "grid"
              ],
              "sanOptions": [
                  "bathAndOrShower"
              ]
          },
          {
              "ehrPartCode": "120280968-2457246",
              "inAdsPartOid": "ER01444865",
              "partType": "apartment",
              "buildingNr": "27",
              "partNr": "14",
              "entryFloor": 4,
              "totalArea": 45.8,
              "heatedArea": 41.3,
              "nrOfRooms": 2,
              "nrOfKitchens": 1,
              "waterTypes": [
                  "grid"
              ],
              "balconies": [
                  {
                      "category": "unk",
                      "areaM2": 4.5
                  }
              ],
              "sanOptions": [
                  "bathAndOrShower"
              ]
          },
          {
              "ehrPartCode": "120280968-2457248",
              "inAdsPartOid": "ER01444868",
              "partType": "apartment",
              "buildingNr": "27",
              "partNr": "15",
              "entryFloor": 4,
              "totalArea": 62.7,
              "heatedArea": 55.5,
              "nrOfRooms": 3,
              "nrOfKitchens": 1,
              "waterTypes": [
                  "grid"
              ],
              "balconies": [
                  {
                      "category": "unk",
                      "areaM2": 7.2
                  }
              ],
              "sanOptions": [
                  "bathAndOrShower"
              ]
          },
          {
              "ehrPartCode": "120280968-2457250",
              "inAdsPartOid": "ER01444871",
              "partType": "apartment",
              "buildingNr": "27",
              "partNr": "16",
              "entryFloor": 4,
              "totalArea": 23.6,
              "heatedArea": 23.6,
              "nrOfRooms": 1,
              "nrOfKitchens": 1,
              "waterTypes": [
                  "grid"
              ],
              "sanOptions": [
                  "bathAndOrShower"
              ]
          },
          {
              "ehrPartCode": "120280968-2457252",
              "inAdsPartOid": "ER01444874",
              "partType": "apartment",
              "buildingNr": "27",
              "partNr": "17",
              "entryFloor": 4,
              "totalArea": 39.1,
              "heatedArea": 39.1,
              "nrOfRooms": 2,
              "nrOfKitchens": 1,
              "waterTypes": [
                  "grid"
              ],
              "sanOptions": [
                  "bathAndOrShower"
              ]
          },
          {
              "ehrPartCode": "120280968-2457256",
              "inAdsPartOid": "ER01444877",
              "partType": "apartment",
              "buildingNr": "27",
              "partNr": "18",
              "entryFloor": 4,
              "totalArea": 58.9,
              "heatedArea": 58.9,
              "nrOfRooms": 3,
              "waterTypes": [
                  "grid"
              ],
              "sanOptions": [
                  "bathAndOrShower"
              ]
          },
          {
              "ehrPartCode": "120280968-2457258",
              "inAdsPartOid": "ER01444880",
              "partType": "apartment",
              "buildingNr": "27",
              "partNr": "19",
              "entryFloor": 4,
              "totalArea": 59.1,
              "heatedArea": 59.1,
              "nrOfRooms": 3,
              "nrOfKitchens": 1,
              "waterTypes": [
                  "grid"
              ],
              "sanOptions": [
                  "bathAndOrShower"
              ]
          }
      ]
  }
}



// WEBPACK FOOTER //
// ./src/functions.js